/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectResourceFreelancerRateResource
 */
export interface ProjectResourceFreelancerRateResource {
    /**
     * 
     * @type {number}
     * @memberof ProjectResourceFreelancerRateResource
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectResourceFreelancerRateResource
     */
    unit: ProjectResourceFreelancerRateResourceUnitEnum;
}


/**
 * @export
 */
export const ProjectResourceFreelancerRateResourceUnitEnum = {
    Daily: 'DAILY',
    Hourly: 'HOURLY'
} as const;
export type ProjectResourceFreelancerRateResourceUnitEnum = typeof ProjectResourceFreelancerRateResourceUnitEnum[keyof typeof ProjectResourceFreelancerRateResourceUnitEnum];


/**
 * Check if a given object implements the ProjectResourceFreelancerRateResource interface.
 */
export function instanceOfProjectResourceFreelancerRateResource(value: object): value is ProjectResourceFreelancerRateResource {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    return true;
}

export function ProjectResourceFreelancerRateResourceFromJSON(json: any): ProjectResourceFreelancerRateResource {
    return ProjectResourceFreelancerRateResourceFromJSONTyped(json, false);
}

export function ProjectResourceFreelancerRateResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectResourceFreelancerRateResource {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'unit': json['unit'],
    };
}

export function ProjectResourceFreelancerRateResourceToJSON(value?: ProjectResourceFreelancerRateResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'unit': value['unit'],
    };
}

